import { useState, useEffect, useRef } from "react";

function getSize() {
  return {
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    outerHeight: window.outerHeight,
    outerWidth: window.outerWidth
  };
}

export default function useWindowSize() {
  const [windowSize, setWindowSize] = useState(getSize());
  const width = useRef(windowSize.innerWidth);
  const height = useRef(windowSize.innerHeight);
  const handleResize = () => {
    const size = getSize();
    if (
      size.innerWidth !== width.current ||
      size.innerHeight !== height.current
    ) {
      width.current = size.innerWidth;
      height.current = size.innerHeight;
      setWindowSize(size);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowSize;
}
